import taxonomyService from '@/services/taxonomy.service';
import { reactive } from 'vue';

class Store {
    state = reactive({
        taxonomy: null
    });

    getters = {
        taxonomy: () => this.state.taxonomy,
        currentUser: () => this.state.taxonomy?.currentUser || {}
    };

    mutations = {
        setTaxonomy: (taxonomy = {}) => (this.state.taxonomy = taxonomy)
    };

    actions = {
        loadTaxonomy: async () => {
            if (this.state.taxonomy != null) return this.state.taxonomy;

            const taxonomy = await taxonomyService.getTaxonomy();
            this.mutations.setTaxonomy(taxonomy);
            return taxonomy;
        }
    };
}

export default new Store();
